import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMapMarker = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M18.286 11.429c0-1.27-1.016-2.286-2.286-2.286s-2.286 1.016-2.286 2.286S14.73 13.714 16 13.714s2.286-1.016 2.286-2.285zm2.285 0C20.571 13.969 18.54 16 16 16s-4.571-2.032-4.571-4.571c0-2.54 2.031-4.572 4.571-4.572s4.571 2.032 4.571 4.572zm4.572 0c0-5.048-4.095-9.143-9.143-9.143S6.857 6.38 6.857 11.429c0 1.428.286 2.825.984 4.063l7.81 14.222h.698l7.81-14.222c.698-1.238.984-2.635.984-4.063zm2.286 0c0 1.84-.413 3.619-1.239 5.142L17.714 32h-3.428L5.81 16.571c-.826-1.523-1.24-3.301-1.24-5.141A11.421 11.421 0 0 1 16 0a11.421 11.421 0 0 1 11.429 11.429z" /></svg>;
export default SvgMapMarker;